// Makao is not a solitaire: its own module plays it (makao/, .ai/makao.md). This stand-in only
// gives the shell a game id it knows (menu, Games window, options, New game / Retry, the shuffle pattern of the first
// deal): no columns, no foundations, the 52 cards stay on a stock nobody sees; no card can be moved here.
import type { VariantRules } from './base';

export const makao: VariantRules = {
  id: 'makao',
  columns: [],
  foundations: 0,
  cells: 0,
  decks: 1,
  suits: ['c', 's', 'd', 'h'],
  variableSuits: 0,
  turn: 1,
  hasWaste: false,
  recycle: false,
  allFaceUp: false,
  autoMove: false,
  foundationToTableau: false,
  canLift: () => false,
  canDrop: () => false,
  foundationFor: () => null,
  buildsOn: () => false,
  completedRun: () => false,
  isWon: () => false,
  table: 'makao',
};
